export default "__VITE_ASSET__JeUEKGd4__"